<template>
  <div class="form-item-date" :class="{ range: isDateRange }">
    <el-date-picker
      style="width: 100%"
      @change="transformDate"
      v-bind="{
        startPlaceholder: $MGUI.i18n.t('开始日期'),
        endPlaceholder: $MGUI.i18n.t('结束日期'),
        valueFormat: 'timestamp',
        ...$attrs,
      }"
      v-on="$listeners"
    />
    <div class="shortcut-date" v-if="isDateRange">
      <template v-for="date in shortcutDateList">
        <span @click="handleShortcutDate(date)" :key="date.value">{{ date.label }}</span>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FormItemDate',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      shortcutDateList() {
        if (this.item && Array.isArray(this.item.shortcutDateList) && this.item.shortcutDateList.length > 0) {
          return this.item.shortcutDateList
        }
        return [
          { label: this.$MGUI.i18n.t('昨'), type: 'day', value: -1 },
          { label: this.$MGUI.i18n.t('今'), type: 'day', value: 0 },
        ]
      },
      isDateRange() {
        return this.$attrs.type === 'daterange'
      },
    },
    methods: {
      transformDate(date) {
        if (!this.isDateRange || date === null) {
          this.$emit('dateChange', date)
          return
        }
        const startDate = this.dayjs(date[0]).startOf('day').valueOf()
        const endDate = this.dayjs(date[1]).endOf('day').valueOf()
        this.$emit('input', [startDate, endDate])
        this.$emit('dateChange', [startDate, endDate])
      },
      handleShortcutDate(date) {
        const now = this.dayjs()
        let startDate
        let endDate

        if (date.type === 'week') {
          // 本周：以周一为起始，周日为结束
          const dayOfWeek = now.day()
          const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
          startDate = now.add(mondayOffset, 'day').startOf('day').valueOf()
          endDate = now
            .add(mondayOffset + 6, 'day')
            .endOf('day')
            .valueOf()
        } else {
          const targetDate = now.add(date.value || 0, date.type)
          startDate = targetDate.startOf(date.type).valueOf()
          endDate = targetDate.endOf(date.type).valueOf()
        }

        this.$emit('input', [startDate, endDate])
        this.$emit('dateChange', [startDate, endDate])
      },
      getDisplayValue() {
        return this.$children[0].displayValue.join?.(this.$MGUI.i18n.t('至'))
      },
    },
  }
</script>
<style scoped lang="scss">
  .form-item-date {
    position: relative;
    ::v-deep {
      // 通用兜底：日期组件（含 daterange）的显示字号统一为 18px
      .el-date-editor .el-input__inner,
      .el-date-editor .el-range-input,
      .el-date-editor .el-range-separator {
        font-size: 18px;
      }
      // 日期值统一左对齐（单日期/日期范围）
      .el-date-editor .el-input__inner,
      .el-date-editor .el-range-input {
        text-align: left;
      }
    }
    .shortcut-date {
      --shortcut-border-color: #dcdfe6;
      --shortcut-hover-border-color: #c7c8cc;
      --shortcut-hover-bg-color: #f5f7fa;
      display: flex;
      align-items: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      span {
        width: 0;
        max-width: 0;
        padding: 0;
        height: 40px;
        line-height: 40px;
        display: block;
        text-align: center;
        background: #fff;
        opacity: 0;
        overflow: hidden;
        pointer-events: none;
        box-sizing: border-box;
        border: 0;
        transition: max-width 200ms, padding 200ms, opacity 200ms, border-color 200ms, background-color 200ms, color 200ms;
        &:hover {
          color: $mg--color-primary;
          border-color: var(--shortcut-hover-border-color);
          background-color: var(--shortcut-hover-bg-color);
        }
      }
      span:last-child {
        width: 40px;
        max-width: 40px;
        padding: 0;
        opacity: 1;
        overflow: visible;
        pointer-events: auto;
        box-sizing: border-box;
        border-top: 1px solid var(--shortcut-border-color);
        border-bottom: 1px solid var(--shortcut-border-color);
        border-left: 1px solid var(--shortcut-border-color);
        border-right: 1px solid var(--shortcut-border-color);
        border-radius: 0 2px 2px 0;
      }
      &:hover span {
        width: 40px;
        max-width: 40px;
        padding: 0;
        opacity: 1;
        overflow: visible;
        pointer-events: auto;
        box-sizing: border-box;
        border-left: 1px solid var(--shortcut-hover-border-color);
        border-top: 1px solid var(--shortcut-hover-border-color);
        border-bottom: 1px solid var(--shortcut-hover-border-color);
      }
      &:hover span:last-child {
        border-right: 1px solid var(--shortcut-hover-border-color);
      }
    }
    &.range {
      ::v-deep {
        .el-input__icon.el-range__close-icon {
          position: relative;
          right: 22px;
          line-height: 32px;
          font-size: 18px;
        }
      }
    }
  }
</style>
